'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCloudWithArrow, iconCloudWithArrowTag } from '@ni/nimble-components/dist/esm/icons/cloud-with-arrow';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCloudWithArrow };
export { iconCloudWithArrowTag };
export const NimbleIconCloudWithArrow = wrap(IconCloudWithArrow);